module.exports = __webpack_public_path__ + "static/media/share-icon.ab184fdd.svg";